import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import {getToken} from '../../storage'
import {API_BASE_URL} from '../../constants'
export default class SearchInput extends React.Component {


  constructor() {
    super()
    this.handleSearch = this.handleSearch.bind(this)
    this.state = {touched:false}
  }

  componentDidMount () {
    this.search = _.debounce((q)=>{
      this.props.handleSearchInput(q)
    }, 400)
  }


  handleSearch(e) {
    this.setState({touched:true, tVal:e.target.value})
    e.preventDefault()
    this.search(e.target.value)
  }

  render() {

    let inputValue = this.props.value || ""

    if(this.state.touched) {
      inputValue = this.state.tVal
    }

    return <div>
          <input type="text" value={inputValue} className="form-control" onChange={this.handleSearch} placeholder={this.props.placeholder} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/search/search.js